import { createContext } from 'react';
export const ProductPageContext = /*#__PURE__*/createContext({});